module.exports = __webpack_public_path__ + "img/terminal_bac.4048b326.png";